import PropTypes from 'prop-types';
import React from 'react';
import { lookerParams } from '../../../../../shared/lookerParams';
import OutputTab from '../OutputTab';

MarginByPayor.propTypes = {
    activeTab: PropTypes.string,
    onLoadComplete: PropTypes.func,
};

function MarginByPayor(props) {
    return (
        <OutputTab
            activeTab={props.activeTab}
            lookerTemplates={lookerParams.lookerPath.marginByPayorMixTab}
            onLoadComplete={props.onLoadComplete}
            tabLabel="MarginByPayor"
            includeChart
        />
    );
}

export default MarginByPayor;
